import { isEqual } from 'lodash';
import { i18nResponseDto } from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';
import { Attributes } from 'domains/Catalog/Products/pages/components/Variants/types';

export function getTags(tags: string | undefined) {
  return (
    tags
      ?.split(',')
      .map((tag) => tag.trim())
      .filter((tag) => tag) ?? []
  );
}

export function areEqualAttributes(
  originalAttributes: Attributes,
  newAttributes: i18nResponseDto[],
  language: LanguagesType,
) {
  const originalAttributesKeys = Object.keys(originalAttributes);
  const newAttributesKeys = newAttributes.map(
    (attribute) => attribute[language],
  );

  return isEqual(originalAttributesKeys, newAttributesKeys);
}
